module.exports = __webpack_public_path__ + "assets/img/e-b-n-2.23e1d5db.png";